import React, { useState } from 'react';

interface SidebarDocumentTestProps {}

const SidebarDocumentTest: React.FC<SidebarDocumentTestProps> = () => {
  const [selectedItem, setSelectedItem] = useState('overview');

  const menuItems = [
    { id: 'overview', label: 'Overview', icon: '📋' },
    { id: 'documents', label: 'Documents', icon: '📄' },
    { id: 'policies', label: 'Policies', icon: '📜' },
    { id: 'procedures', label: 'Procedures', icon: '⚙️' },
    { id: 'templates', label: 'Templates', icon: '📝' },
    { id: 'reports', label: 'Reports', icon: '📊' },
    { id: 'settings', label: 'Settings', icon: '🔧' },
  ];

  const renderContent = () => {
    switch (selectedItem) {
      case 'overview':
        return (
          <div>
            <h2>Document Management Overview</h2>
            <p>Welcome to the document management system. This area provides a comprehensive view of all your governance documents, policies, and procedures.</p>
            
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '16px', marginTop: '24px' }}>
              <div className="visual-card-medium">
                <h4>📄 Recent Documents</h4>
                <p>Access your most recently updated documents and files.</p>
              </div>
              <div className="visual-card-medium">
                <h4>📊 Document Stats</h4>
                <p>View statistics and metrics about your document library.</p>
              </div>
              <div className="visual-card-medium">
                <h4>🔍 Search & Filter</h4>
                <p>Powerful search capabilities across all document types.</p>
              </div>
            </div>
          </div>
        );
      case 'documents':
        return (
          <div>
            <h2>📄 Document Library</h2>
            <p>Manage all your governance documents in one centralized location.</p>
            <div style={{ marginTop: '20px', padding: '16px', background: '#f8f9fa', borderRadius: '8px' }}>
              <h4>Sample Documents:</h4>
              <ul>
                <li>Corporate Governance Framework v2.1</li>
                <li>Risk Management Policy 2024</li>
                <li>Compliance Audit Report Q3</li>
                <li>Data Privacy Guidelines</li>
                <li>Vendor Management Procedures</li>
              </ul>
            </div>
          </div>
        );
      case 'policies':
        return (
          <div>
            <h2>📜 Policy Management</h2>
            <p>Create, review, and maintain organizational policies and guidelines.</p>
            <div style={{ marginTop: '20px' }}>
              <h4>Policy Categories:</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '12px' }}>
                <div style={{ padding: '8px 12px', background: '#e3f2fd', borderRadius: '6px' }}>Information Security Policies</div>
                <div style={{ padding: '8px 12px', background: '#f3e5f5', borderRadius: '6px' }}>HR & Employment Policies</div>
                <div style={{ padding: '8px 12px', background: '#e8f5e8', borderRadius: '6px' }}>Financial & Compliance Policies</div>
                <div style={{ padding: '8px 12px', background: '#fff3e0', borderRadius: '6px' }}>Operational Policies</div>
              </div>
            </div>
          </div>
        );
      default:
        return (
          <div>
            <h2>{menuItems.find(item => item.id === selectedItem)?.label}</h2>
            <p>Content for {selectedItem} section coming soon...</p>
          </div>
        );
    }
  };

  return (
    <div className="inner-split">
      {/* Left Navigation Menu */}
      <div className="left-menu-area">
        <div style={{ padding: '16px' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: '14px', fontWeight: '600', color: '#374151' }}>
            Document Sections
          </h3>
          <nav>
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => setSelectedItem(item.id)}
                className={`interactive-tree-node ${selectedItem === item.id ? 'active' : ''}`}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  background: selectedItem === item.id ? '#e0f2fe' : 'transparent',
                  color: selectedItem === item.id ? '#0369a1' : '#374151',
                  border: 'none',
                  borderRadius: '6px',
                  marginBottom: '4px',
                  fontWeight: selectedItem === item.id ? '500' : '400',
                }}
              >
                <span style={{ marginRight: '8px' }}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="mid-content-area">
        {renderContent()}
      </div>
    </div>
  );
};

export default SidebarDocumentTest;